import { type ReactElement, useState } from 'react';
import { Outlet, useParams } from 'react-router';

import { useViewer } from '@/entities/session';

import styles from './AppShell.module.scss';
import { ShellHeader } from './ShellHeader';
import { ShellNavigation } from './ShellNavigation';

/** Sidebar navigation, top bar with the user, and the page. */
export function AppShell(): ReactElement | null {
  const viewer = useViewer();
  const { organizationId } = useParams();
  const [menuOpen, setMenuOpen] = useState(false);
  if (!viewer) return null;
  return (
    <div className={styles.shell}>
      <a className={styles.skipLink} href="#main-content">
        К содержимому
      </a>
      <ShellNavigation
        viewer={viewer}
        organizationId={organizationId ? Number(organizationId) : null}
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
      />
      <div className={styles.main}>
        <ShellHeader viewer={viewer} menuOpen={menuOpen} onOpenMenu={() => setMenuOpen(true)} />
        <main className={styles.content} id="main-content" tabIndex={-1}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
